import AbstractField from "./abstract";

class ImageField extends AbstractField{
    __init_dom_schema(){
        return {
            input: {
                selector: 'input[type="file"]',
                actions: {
                    'change': this.onSelected.bind(this)
                }
            },
            image: {
                selector: '.image',
            },
            img: {
                selector: 'img',
            },
            imagebox: {
                selector: '.imagebox',
                actions: {
                    'click|touch': this.openDialog.bind(this)
                }
            }
        }
    }
    __init(){
        this.registerEvents('changed')
    }
    isRequired(){
        // console.log(this)
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.value !== ''
    }
    getValue(){
        return this.dom.input.value
    }
    openDialog(event){
        event.stopPropagation()
        this.dom.input.click()
        this.focus()
    }
    onSelected(event){
        // console.log(event)
        // console.log(this.dom.input.value)
        // console.log(this.dom.input)
        // const name = this.dom.input.value.split(/(\\|\/)/g).pop()
        // this.dom.title.innerHTML = name
        if(this.dom.img){
            this.dom.img.src = this.dom.input.value
            const url = URL.createObjectURL(this.dom.input.files[0])
            this.dom.img.src = url
        }

        if(this.dom.image){
            this.dom.image.classList.remove('-undefined')
        }
        this.dispatchEvent('changed')
    }
    unfocus(){
        
    }
}

export default ImageField